import classNames from "classnames";
import { FC } from "react";
import BillingsTaxiTransferredOrderListingItemBillingStatus from "../../types/billings-taxi-transferred-order-listing-item-billing-status";

type BillingsTaxiTransferredOrderTableStatusProps = {
  status: BillingsTaxiTransferredOrderListingItemBillingStatus | undefined;
};

const BillingsTaxiTransferredOrderListingTableStatusComponent: FC<
  BillingsTaxiTransferredOrderTableStatusProps
> = (props) => {
  const getClassnameByStatus = (): string => {
    switch (props.status) {
      case BillingsTaxiTransferredOrderListingItemBillingStatus.CREATED:
        return "created";
      case BillingsTaxiTransferredOrderListingItemBillingStatus.ACCEPTED:
        return "accepted";
      case BillingsTaxiTransferredOrderListingItemBillingStatus.REJECTED:
        return "rejected";
      case BillingsTaxiTransferredOrderListingItemBillingStatus.REOPENED:
        return "reopened";
      case BillingsTaxiTransferredOrderListingItemBillingStatus.REOPEN_REQUEST:
        return "reopen_request_sent";
      default:
        return "";
    }
  };

  const statusClassname = getClassnameByStatus();

  const containerClassNames = classNames(
    "billings_taxi_transferred_order_listing_table_status",
    statusClassname
  );

  return <div className={containerClassNames}></div>;
};

export default BillingsTaxiTransferredOrderListingTableStatusComponent;
